// src/pages/NoticeDetail.tsx
import React from "react";
import { useParams, Link } from "react-router-dom";

const API = process.env.REACT_APP_API_BASE_URL || "";

export default function NoticeDetail() {
  const { id } = useParams();
  const [row, setRow] = React.useState<any>(null);
  const [err, setErr] = React.useState("");
  const [notFound, setNotFound] = React.useState(false);

  React.useEffect(() => {
    if (!id) {
      setNotFound(true);
      return;
    }

    (async () => {
      try {
        setErr("");
        setNotFound(false);
        setRow(null);

        // ★ 一覧（公開中だけが返ってくる想定）から id で探す
        const res = await fetch(`${API}/api/public/notices`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const json = await res.json();
        const items: any[] = Array.isArray(json)
          ? json
          : Array.isArray(json?.items)
          ? json.items
          : [];

        const found = items.find(
          (n: any) => String(n.id) === String(id)
        );

        if (!found) {
          // 削除済み or 非公開
          setNotFound(true);
          return;
        }

        setRow(found);
      } catch (e: any) {
        setErr(e.message || "取得に失敗しました。");
      }
    })();
  }, [id]);

  const Main = (props: { children: React.ReactNode }) => (
    <main
      style={{
        maxWidth: 960,
        margin: "24px auto",
        padding: "0 12px",
      }}
    >
      {props.children}
    </main>
  );

  if (notFound) {
    return (
      <Main>
        <p>このお知らせは存在しないか、削除されました。</p>
        <div style={{ marginTop: 16 }}>
          <Link to="/notices" style={{ textDecoration: "underline" }}>
            ← お知らせ一覧へ
          </Link>
        </div>
      </Main>
    );
  }

  if (err) {
    return (
      <Main>
        取得に失敗しました。
        <div style={{ marginTop: 16 }}>
          <Link to="/notices" style={{ textDecoration: "underline" }}>
            ← お知らせ一覧へ
          </Link>
        </div>
      </Main>
    );
  }

  if (!row) {
    return <Main>読込中…</Main>;
  }

  return (
    <Main>
      <h1 style={{ fontSize: 20, marginBottom: 12 }}>{row.title}</h1>
      {row.createdAt && (
        <div
          style={{
            fontSize: 12,
            opacity: 0.7,
            marginBottom: 8,
          }}
        >
          {new Date(row.createdAt).toLocaleString()}
        </div>
      )}
      {row.body && (
        <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
          {row.body}
        </div>
      )}
      {row.linkUrl && (
        <div style={{ marginTop: 12 }}>
          <a
            href={row.linkUrl}
            style={{
              color: "#1976d2",
              textDecoration: "underline",
            }}
          >
            関連リンク
          </a>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <Link to="/notices" style={{ textDecoration: "underline" }}>
          ← お知らせ一覧へ
        </Link>
      </div>
    </Main>
  );
}
